import classNames from "classnames";
import { PhoneContact } from "../../../lib/api/models";
import { INPUT_MASKS, maskInput } from "../../../lib/formatting";
import LabeledInfo from "../../common/LabeledInfo";
import styles from "./PhoneNumberDisplay.module.css";

const strings = {
  phoneNumberLabel: "Phone Number",
  extensionLabel: "Ext.",
  primary: "Primary",
  secondary: "Secondary",
};

type Props = {
  phoneContact: PhoneContact;
};

export default function PhoneNumberDisplay({
  phoneContact: { phoneNumber, extension, isPrimary, isSecondary },
}: Props) {
  return (
    <div className={styles.container}>
      <LabeledInfo
        orientation="vertical"
        label={strings.phoneNumberLabel}
        value={maskInput(INPUT_MASKS.phoneNumber, phoneNumber)}
      />
      <LabeledInfo
        orientation="vertical"
        label={strings.extensionLabel}
        value={extension ?? "-"}
      />
      <div className={styles.badgeRow}>
        {isPrimary ? (
          <div className={classNames(styles.badge, styles.primary)}>
            {strings.primary}
          </div>
        ) : null}
        {isSecondary ? (
          <div className={classNames(styles.badge, styles.secondary)}>
            {strings.secondary}
          </div>
        ) : null}
      </div>
    </div>
  );
}
